import { IPartnerFlag, TPartnerFlagResponse } from '../../../models'

export function mapPartnerFlagFromRequest(request: TPartnerFlagResponse): IPartnerFlag {
  return {
    action: request.Action,
    caption: request.Caption,
    code: request.Code,
    codeName: request.CodeName,
    codeType: request.Type,
    comment: request.Comment,
    country: request.Country,
    endDate: new Date(request.EndDate),
    newEffectiveDate: request.NewEffectiveDate ? new Date(request.NewEffectiveDate) : undefined,
    entryId: request.EntryId,
    market: request.Market,
    partnerId: request.PartnerId,
    startDate: new Date(request.StartDate),
    status: request.Status,
  }
}
